import React from 'react';

const STAGES = [
  ['fieldManagerStatus', 'CRO'],
  ['branchManagerStatus', 'Branch Manager'],
  ['misStatus', 'MIS'],
  ['accountManagerStatus', 'Accounts Manager'],
];

const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  return isNaN(date.getTime())
    ? '-'
    : date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

const cellStyle = { padding: '4px 8px', borderTop: '1px solid #FECACA', fontSize: '0.8rem' };
const notDone = { ...cellStyle, color: '#991B1B', fontWeight: 600 };

// Shown on the foreclosure screen while any receipt is not paid or not
// submitted at every manager stage. The screen stays read-only until cleared.
const UnclearedReceiptsAlert = ({ receipts }) => (
  <div
    role="alert"
    className="mb-4"
    style={{ background: '#FEF2F2', border: '1px solid #DC2626', borderRadius: '8px', padding: '12px 16px', color: '#991B1B' }}
  >
    <div style={{ fontWeight: 700, fontSize: '0.95rem', marginBottom: '4px' }}>
      Foreclosure is not allowed yet. {receipts.length} receipt{receipts.length > 1 ? 's are' : ' is'} not cleared.
    </div>
    <div style={{ fontSize: '0.82rem', marginBottom: '8px' }}>
      Every receipt must be status "paid" and submitted by CRO, Branch Manager, MIS and Accounts Manager.
      This customer's receipt state is:
    </div>
    <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', background: '#FFFFFF' }}>
        <thead>
          <tr style={{ background: '#FEE2E2', fontSize: '0.78rem', textAlign: 'left' }}>
            <th style={{ padding: '6px 8px' }}>Receipt No</th>
            <th style={{ padding: '6px 8px' }}>Collected</th>
            <th style={{ padding: '6px 8px' }}>Amount</th>
            <th style={{ padding: '6px 8px' }}>Receipt Status</th>
            {STAGES.map(([key, label]) => (
              <th key={key} style={{ padding: '6px 8px' }}>{label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {receipts.map((receipt) => (
            <tr key={receipt.receiptId}>
              <td style={cellStyle}>{receipt.receiptNo || `#${receipt.receiptId}`}</td>
              <td style={cellStyle}>{formatDate(receipt.collectedDate)}</td>
              <td style={cellStyle}>₹{receipt.receivedAmount}</td>
              <td style={receipt.status === 'paid' ? cellStyle : notDone}>{receipt.status || '-'}</td>
              {STAGES.map(([key]) => (
                <td key={key} style={receipt[key] === 'submitted' ? cellStyle : notDone}>
                  {receipt[key] || 'no record'}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default UnclearedReceiptsAlert;
